import React, { type PropsWithChildren } from 'react';
import { SnackBar } from '../../../../app/components/SnackBar';

const AuthorizationLayout = (props: PropsWithChildren) => {
  return (
    <div className="container-lg">
      <div className="authorization">
        <SnackBar />
        {props.children}
      </div>
    </div>
  );
};

export default AuthorizationLayout;
